import React, {} from "react"

const paths = require('../../../paths.json');

export default function update_filter_state(event, filter_category, new_state, page='home', influencer = null) {
   event.preventDefault();
   // try and get the current state
   let category_filter = this.state.sort_filter_category
   let tier_filter  = this.state.sort_filter_tier
   let time_filter = this.state.sort_filter_time
   let content_filter = this.state.sort_filter_content 
   let other_filter = this.state.sort_filter_other 
   let sort_filter = this.state.sort_filter_sort
   try {
      var current_val = eval('this.state.sort_filter_' + filter_category)
   } catch (err) {
      var current_val = null
   }
   if (current_val === new_state) {
      // Reset category filter on second click
      if (filter_category == 'category' || filter_category == 'content') {
         new_state = 'All'
         eval('this.setState({sort_filter_' + filter_category + ': "All"})')
         eval(filter_category + '_filter = new_state')
      }
      else if (filter_category === 'sort'){
         if (page === 'home'){
            eval('this.setState({sort_filter_' + filter_category + ': "Trending"})')
            sort_filter = 'Trending'
         } else if (page === 'influencer'){
            eval('this.setState({sort_filter_' + filter_category + ': "Latest"})')
            sort_filter = 'Latest'
         }
      } else {
         eval('this.setState({sort_filter_' + filter_category + ': "All"})')
         eval(filter_category + '_filter = new_state')
      }
   } else {
      eval('this.setState({sort_filter_' + filter_category + ': "' + new_state + '"})')
      eval(filter_category + '_filter = new_state')
   }
   if (filter_category != 'view_type'){
      if (page === 'home'){
         this.setState({content_list: []})
         // this.handleObserver()
         if (window.innerWidth > 1560){
            this.get_and_post_data_skeleton(
               paths.BACKEND_URL + "api/home_page_content_data/" + category_filter + '/' + tier_filter +  '/' + time_filter + '/' + content_filter + '/' + other_filter + '/' + sort_filter + '/1/20',
              'get',
              true,
              {},
              null,
              false,
              true,
          )  
          this.setState({inf_scroll_page_num: 6})
          this.setState({inf_scroll_loading: false})
        } else if (window.innerWidth > 1280){
         this.get_and_post_data_skeleton(
            paths.BACKEND_URL + "api/home_page_content_data/" + category_filter + '/' + tier_filter +  '/' + time_filter + '/' + content_filter + '/' + other_filter + '/' + sort_filter + '/1/16',
           'get',
           true,
           {},
           null,
           false,
           true,
       )  
       this.setState({inf_scroll_page_num: 5})
       this.setState({inf_scroll_loading: false})
        } else if (window.innerWidth > 900){
         this.get_and_post_data_skeleton(
            paths.BACKEND_URL + "api/home_page_content_data/" + category_filter + '/' + tier_filter +  '/' + time_filter + '/' + content_filter + '/' + other_filter + '/' + sort_filter + '/1/12',
           'get',
           true,
           {},
           null,
           false,
           true,
       )  
       this.setState({inf_scroll_page_num: 4})
       this.setState({inf_scroll_loading: false})
        } else if (window.innerWidth > 600){
            this.get_and_post_data_skeleton(
               paths.BACKEND_URL + "api/home_page_content_data/" + category_filter + '/' + tier_filter +  '/' + time_filter + '/' + content_filter + '/' + other_filter + '/' + sort_filter + '/1/8',
            'get',
            true,
            {},
            null,
            false,
            true,
         )  
         this.setState({inf_scroll_page_num: 3})
         this.setState({inf_scroll_loading: false})
        } else {
            this.get_and_post_data_skeleton(
                 paths.BACKEND_URL + "api/home_page_content_data/" + category_filter + '/' + tier_filter +  '/' + time_filter + '/' + content_filter + '/' + other_filter + '/' + sort_filter + '/1/4',
                'get',
                true,
                {},
                null,
                false,
                true,
            )  
            this.setState({inf_scroll_page_num: 2})
            this.setState({inf_scroll_loading: false})
        }
      } else if (page === 'influencer'){
         this.setState({influencer_content: []})
         this.setState({inf_scroll_page_num: 1})
         // this.handleObserver()
         this.get_and_post_data_skeleton(
            paths.BACKEND_URL + "api/influencer_page_content_data/" +
            category_filter + '/' + tier_filter + '/'
            + time_filter + '/' + content_filter + '/'
            + other_filter + '/' + sort_filter + '/'
            + this.state.influencer_name + '/' + 1,
            'get',
            false,
         )
         this.setState({inf_scroll_loading: false})
      }
   }
}
